import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/redux.store'
import { mapAllBoardStickersToBoardStickerRows } from '../../lib/taskTrackerBoardStickerRows.utils'
import type { BoardStickerRow } from '../domain.types'
import type { TaskTrackerState } from '../index'
import { EMPTY_BOARD_STICKERS_TAB_BOARD_STATE } from './boardStickersTab.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardStickersTab = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return EMPTY_BOARD_STICKERS_TAB_BOARD_STATE

  return (
    state.taskTracker.boardStickersTab.byBoardId[boardId] ??
    EMPTY_BOARD_STICKERS_TAB_BOARD_STATE
  )
}

const mapBoardStickersToRows = (
  stickers: typeof EMPTY_BOARD_STICKERS_TAB_BOARD_STATE.boardStickers,
): BoardStickerRow[] => mapAllBoardStickersToBoardStickerRows(stickers)

export const makeSelectTaskTrackerBoardStickerRows = (boardId: number | null) =>
  createSelector(
    [
      (state: AppState) =>
        boardId != null
          ? state.taskTracker.boardStickersTab.byBoardId[boardId]
          : undefined,
    ],
    (boardState): BoardStickerRow[] => {
      const tabState = boardState ?? EMPTY_BOARD_STICKERS_TAB_BOARD_STATE
      return mapBoardStickersToRows(tabState.boardStickers)
    },
  )
